var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNextBtnPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 14.306,
    viewBox: "0 0 22 14.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9468",
    transform: "translate(0 .121)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v14H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10396"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 192",
    d: "m68.319 3 5.249 4.992-5.249 5.072",
    transform: "translate(-54.032 -.879)",
    style: {
      stroke: "#7833ba",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 5",
    transform: "translate(2 7.153)",
    style: {
      stroke: "#7833ba",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      fill: "none"
    },
    d: "M0 .04 16.464 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNextBtnPurple);
export default __webpack_public_path__ + "static/media/icon_next_btn_Purple.cfa553b7633ad3eaddf26e91f0bc2847.svg";
export { ForwardRef as ReactComponent };